import { Button, ButtonGroup } from '@chakra-ui/react';
import { useEffect, useState } from 'react';

export const ASCENDING_ORDER = 'asc';
export const DESCENDING_ORDER = 'desc';

interface ToggleButtonGroupProps {
    options: string[];
    onSortChange: (newState: string, sortOrder: string) => void;
}

export const ToggleButtonGroup: React.FC<ToggleButtonGroupProps> = ({ options, onSortChange }) => {
    const [selectedIndex, setSelectedIndex] = useState<number>(0);
    const [sortOrder, setSortOrder] = useState<string>(DESCENDING_ORDER);

    const handleButtonClick = (clickedIndex: number) => {
        if (clickedIndex === selectedIndex) {
            toggleSortOrder();
        } else {
            setSelectedIndex(clickedIndex);
            setSortOrder(DESCENDING_ORDER);
        }
    };

    const toggleSortOrder = () => {
        if (sortOrder === DESCENDING_ORDER) {
            setSortOrder(ASCENDING_ORDER);
        } else {
            setSortOrder(DESCENDING_ORDER);
        }
    };

    useEffect(() => {
        onSortChange(options[selectedIndex], sortOrder);
    }, [selectedIndex, sortOrder]);

    return (
        <ButtonGroup className={'toggle-button-component'}>
            {options.map((option, idx) =>
                idx === selectedIndex ? (
                    <Button
                        className={'toggle-button-selected'}
                        key={idx}
                        onClick={() => {
                            handleButtonClick(idx);
                        }}
                    >
                        {option}
                        {sortOrder === ASCENDING_ORDER ? '\xa0\xa0^' : '\xa0\xa0\u2304'}
                    </Button>
                ) : (
                    <Button
                        className={'toggle-button-off'}
                        key={idx}
                        onClick={() => {
                            handleButtonClick(idx);
                        }}
                    >
                        {option}
                    </Button>
                ),
            )}
        </ButtonGroup>
    );
};
